<template>
    <div class="section-no-padding">
        <carousel :navigationEnabled="false" :paginationEnabled="true" :per-page="1" autoplay :autoplayTimeout="5000" loop :mouse-drag="false" ref="carousel" class="carousel">
            <slide v-for="(item, index) in items" :key="index" class="slide">
                <div class="overlay">
                    <transition name="slide">
                        <div v-show="index === current">
                            <h3>{{ item.title }}</h3>
                            <h1>{{ item.slogan }}</h1>
                        </div>
                    </transition>
                </div>
                <div v-html="item.header_image_html"></div>
            </slide>
        </carousel>
    </div>
</template>

<script>
    import objectFitImages from 'object-fit-images';

    export default {
        props: {
            items: Array
        },
        data() {
            return {
                current: 0,
            }
        },
        mounted() {
            let that = this;
            this.$watch(
                () => {
                    return this.$refs.carousel.currentPage
                },
                val => {
                    that.current = val;
                }
            );

            objectFitImages();
        },
    }
</script>

<style scoped>

    .carousel >>> .VueCarousel-inner {
        transition-delay: .3s !important;
    }

    .slide-enter-active {
        animation: slide-in .5s forwards .5s;
    }

    .slide-leave-active {
        animation: slide-out .5s forwards;
    }


    @media (min-width: 992px) {

        .carousel >>> img {
            height: 85vh;
            width: 100%;
            object-fit: cover;
            font-family: 'object-fit: cover;';
        }
    }

    @keyframes slide-in {
        0% {
            transform: translateY(100px);
            opacity: 0;
        }
        100% {
            transform: translateY(0px);
            opacity: 1;
        }
    }

    @keyframes slide-out {
        0% {
            transform: translateY(0px);
            opacity: 1;
        }
        100% {
            transform: translateY(-100px);
            opacity: 0;
        }
    }
</style>



// WEBPACK FOOTER //
// resources/assets/components/Kernwaarden.vue